import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';

import PRICE_BOOST_ITEM from './price-boost-item.palette-schema.yaml';

registerTileSchema(PRICE_BOOST_ITEM);

export function generatePriceBoostItem(TILE) {
    return {
        marketLabel: {
            style: {
                ...TILE.PBI_MARKET_NAME_TEXT,
            },
        },
        selectionLabel: {
            style: {
                ...TILE.PBI_SELECTION_NAME_TEXT,
            },
        },
        priceInformationContainer: {
            style: {
                alignItems: 'center',
            },
        },
        wasTitle: {
            style: {
                ...TILE.PBI_PREVIOUS_PRICE_HEADER_TEXT,
            },
        },
        wasContainer: {
            style: {
                justifyContent: 'center',
            },
        },
        wasPrice: {
            style: {
                ...TILE.PBI_PREVIOUS_PRICE_TEXT,
            },
        },
        indicationIcon: {
            src: 'double-arrow-right',
            style: {
                minHeight: 12,
                minWidth: 12,
                height: 12,
                width: 12,
                fill: TILE.PBI_PREVIOUS_PRICE_INDICATION_ICON_COLOR,
            },
        },
        selectionButton: generateOddsButton(TILE.PBI_ODDS_BUTTON),
    };
}
